<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	//Design system components
	import { Alert, SelectCard, Text } from '@Shelly/shelly-design-system';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import { _format } from 'src/stores/features/device-notifications';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	let className = '';
	export { className as class };

	export let device: any;
	export let settings: any,
		icon: string = '';

	const property = 'range';
	const component = 'voltmeter:200';
	const supported_modes = ['analog_in'];

	const options = [
		{
			title: _format('settings_pill_options_analog_range_0', {
				default: '0 - 2.5V (default)',
			}),
			optionValue: 0,
		},
		{
			title: _format('settings_pill_options_analog_range_1', {
				default: '0 - 30V (requires add-on)',
			}),
			optionValue: 1,
		},
	];
	$: value = settings?.[component]?.[property] || 0;

	$: disabled = waitingRorRequest || !supported_modes.includes(settings?.pill?.mode);

	let waitingRorRequest = false;

	const onChange = async (newValue: number) => {
		if (waitingRorRequest) return;
		waitingRorRequest = true;
		const res: SettingRequest = await gen2Request(device, 'Voltmeter.SetConfig', {
			id: 200,
			config: { [property]: newValue },
		});
		onSettingsResponse(res, device);

		if (res.isok) {
			settings[component][property] = newValue;
		}
		waitingRorRequest = false;
	};
</script>

<div class={className}>
	<Text styleType="h2" class="mb-s">
		{$format('subtitle_pill_peripheral_analog_range', {
			default: 'Voltage Measurement Range',
		})}
	</Text>
	<Alert
		type="info"
		class="mb-s"
		heading={$format('alert_pill_peripheral_analog_range_heading', {
			default: 'Extended Voltage Range',
		})}
		message={$format('alert_pill_peripheral_analog_range', {
			default:
				'Ensure the connected add-on is compatible with the selected range to avoid inaccurate readings or potential damage. Default: 0 - 2.5V.',
		})}
	/>
	{#each options as { title, optionValue }}
		<SelectCard
			cardBgColor={$showNewLayout ? 'color-1' : undefined}
			{title}
			descriptiveText={''}
			type="horizontal"
			variant="radio"
			selected={optionValue === (value || options?.[0]?.optionValue)}
			on:click={() => {
				onChange(optionValue);
			}}
			{disabled}
			class="width-full mt-xs"
			icon={waitingRorRequest ? 'fal fa-spinner fa-spin' : icon}
		></SelectCard>
	{/each}
</div>
